import * as types from '../mutation-types'
import moment from 'moment'

export default store => {
  const getMsUntilNextMinute = () => moment()
    .add(1, 'm')
    .set({ millisecond: 0, second: 0 })
    .subtract(moment().valueOf(), 'milliseconds')
    .valueOf()

  const setCurrentTime = () => {
    store.commit(types.SET_CURRENT_MINUTE, moment().toISOString())
    setTimeout(setCurrentTime, getMsUntilNextMinute())
  }

  store.commit(types.SET_CURRENT_MINUTE, moment().toISOString())
  setTimeout(setCurrentTime, getMsUntilNextMinute())
}
